<template>
  <button
    data-base-button
    :class="buttonClass">
    <slot></slot>
  </button>
</template>

<script>
import classnames from 'classnames'
import vueTypes from 'vue-types'

export default {
  name: 'BaseButton',

  props: {
    theme: vueTypes.string,
    selected: vueTypes.bool
  },

  computed: {
    buttonClass () {
      if (this.theme === 'light') {
        return classnames(this.$style.buttonLight, {
          [this.$style.buttonLightSelected]: this.selected
        })
      }

      return classnames(this.$style.button, {
        [this.$style.buttonSelected]: this.selected
      })
    }
  }
}
</script>

<style module>
  .button {
    display: inline-block;
    background-color: transparent;
    border: 1px solid rgba(0,0,0,0.1);
    color: rgba(0,0,0,0.7);
    white-space: nowrap;
    font-size: 15px;
    padding: 6px 12px;
    margin-left: 10px;
    font-family: 'Inter', sans-serif;
    border-radius: var(--border-radius-career-filter);
    line-height: 22px;
    text-align: center;
    font-weight: 400;
    vertical-align: middle;
    cursor: pointer;
    outline: none;
    transition: all 300ms ease-out;

    &:first-child {
      margin-left: 0;
    }

    &:hover {
      background: rgba(0,0,0,0.7);
      border: 1px solid transparent;
      color: white;
    }
  }

  .buttonSelected {
    background: rgba(0,0,0,0.7);
    border: 1px solid transparent;
    color: white;
  }

  .buttonLight {
    composes: button;
    background-color: transparent;
    border-color: rgba(255,255,255,0.2);
    color: rgba(255,255,255,0.7);

    &:hover {
      background-color: rgba(255,255,255,0.7);
      border-color: transparent;
      color: rgba(0,0,0,0.8);
    }
  }

  .buttonLightSelected {
    background-color: rgba(255,255,255,0.7);
    border-color: transparent;
    color: rgba(0,0,0,0.8);
  }
</style>
